import { LogicalOperator } from '@aipb/gulliver/castor/model';
import { FormSettingsModel, SearchFormMode } from '@aipb/gulliver/catalog/model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { getFormSettingIcon } from '../../settings.helpers';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-search-settings',
  templateUrl: './search-settings.component.html',
  styleUrls: ['./search-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatSlideToggleModule, MatIconModule, TranslocoModule]
})
export class SearchSettingsComponent {
  @Input() logicalOperator: LogicalOperator;
  @Input() searchFormMode: SearchFormMode;

  @Output() formSettingToggle: EventEmitter<string> = new EventEmitter<string>();
  @Output() logicalOperatorChange = new EventEmitter<LogicalOperator>();
  @Output() searchFormModeChange = new EventEmitter<SearchFormMode>();

  logicalOperators: LogicalOperator[] = ['AND', 'OR'];
  searchFormModes: SearchFormMode[] = ['simple', 'advanced'];

  private _labels: {
    [key: string]: string;
  };
  private _icons: {
    [key: string]: string;
  };

  private transloco = inject(TranslocoService);

  private _formSettings: FormSettingsModel;

  get formSettings(): FormSettingsModel {
    return this._formSettings;
  }

  @Input() set formSettings(value: FormSettingsModel) {
    this._formSettings = value;
    this.initLabels();
    this.initIcons();
  }

  public getLabel(key: string): string {
    if (!(key in this._labels)) return '';

    return this._labels[key];
  }

  public getKeys(settings: FormSettingsModel): string[] {
    if (!settings) return [];

    return Object.keys(settings);
  }

  public getIcon(key: string): string {
    if (!(key in this._icons) || !this._icons[key]) return 'help';

    return this._icons[key];
  }

  private initLabels(): void {
    if (!this._formSettings) return;

    this._labels = {};

    for (const key of Object.keys(this._formSettings)) {
      this._labels[key] = 'catalog.form_search.form_settings.' + key;
    }
  }

  private initIcons() {
    if (!this._formSettings) return;

    this._icons = {};

    for (const key of Object.keys(this._formSettings)) {
      this._icons[key] = getFormSettingIcon(key, this._formSettings[key]);
    }
  }
}
